import { render, staticRenderFns } from "./timeclick.vue?vue&type=template&id=155d1df4&scoped=true&"
import script from "./timeclick.vue?vue&type=script&lang=js&"
export * from "./timeclick.vue?vue&type=script&lang=js&"
import style0 from "./timeclick.vue?vue&type=style&index=0&id=155d1df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d1df4",
  null
  
)

export default component.exports